webpackJsonp([1],{

/***/ "57t0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"mainContainer":"Game-mainContainer--1Utj4","cardsContainer":"Game-cardsContainer--2H3zY","unClickable":"Game-unClickable--3TfuD","resetButton":"Game-resetButton--Np0QA"};

/***/ }),

/***/ "9kH4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"card":"Card-card--tRKnc","cardContent":"Card-cardContent--3J66l","flipped":"Card-flipped--3Db3G","cardFront":"Card-cardFront--3oyDw","cardBack":"Card-cardBack--1Lkmt"};

/***/ }),

/***/ "AL1r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"messageScreen":"MessageDisplay-messageScreen--dVUHA","buttonContainer":"MessageDisplay-buttonContainer--2rceF","timer":"MessageDisplay-timer--cX9GR"};

/***/ }),

/***/ "EAxn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/components/Card/Card.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Card_scss__ = __webpack_require__("9kH4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Card_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Card_scss__);




var Card = function Card(_ref) {
  var img = _ref.img,
      isFlipped = _ref.isFlipped,
      handleClick = _ref.handleClick,
      id = _ref.id,
      index = _ref.index;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      id: id,
      index: index,
      className: [__WEBPACK_IMPORTED_MODULE_2__Card_scss___default.a.card, isFlipped && __WEBPACK_IMPORTED_MODULE_2__Card_scss___default.a.flipped].join(' '),
      onClick: function onClick(e) {
        return handleClick(e, id, index);
      },
      role: 'option',
      'aria-selected': 'false',
      tabIndex: id
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_2__Card_scss___default.a.cardContent },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_2__Card_scss___default.a.cardBack }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_2__Card_scss___default.a.cardFront, style: { backgroundImage: 'url(' + img + ')' } })
    )
  );
};

Card.propTypes = {
  img: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  isFlipped: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  handleClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  index: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

/* harmony default export */ var Card_defaultExport = (Card);
// CONCATENATED MODULE: ./src/components/Timer/Timer.js
/* harmony import */ var Timer___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var Timer___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Timer___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Timer___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var Timer___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(Timer___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Timer_scss__ = __webpack_require__("aFXg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Timer_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Timer_scss__);





var formatTime = function formatTime(time) {
  if (time < 0) return '--:--';
  var h = Math.floor(time / 3600);
  var m = Math.floor(time % 3600 / 60);
  var mm = m < 10 ? '0' + m : m;
  var s = time % 60;
  var ss = s < 10 ? '0' + s : s;
  if (h > 0) return [h, mm, ss].join(':');
  return m + ':' + ss;
};

var Timer = function Timer(props) {
  return Timer___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_2__Timer_scss___default.a.timer },
    formatTime(props.secondsElapsed)
  );
};

Timer.propTypes = {
  secondsElapsed: Timer___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};
/* harmony default export */ var Timer_defaultExport = (Timer);
// CONCATENATED MODULE: ./src/components/MessageDisplay/MessageDisplay.js
/* harmony import */ var MessageDisplay___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var MessageDisplay___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(MessageDisplay___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var MessageDisplay___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var MessageDisplay___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(MessageDisplay___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MessageDisplay_scss__ = __webpack_require__("AL1r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MessageDisplay_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MessageDisplay_scss__);





var MessageDisplay_MessageDisplay = function MessageDisplay(_ref) {
  var mode = _ref.mode,
      typeButtonClick = _ref.typeButtonClick,
      resetButtonClick = _ref.resetButtonClick,
      secondsElapsed = _ref.secondsElapsed;

  var display = void 0;
  function StartScreen() {
    return MessageDisplay___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      MessageDisplay___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h1',
        null,
        'Welcome to the game! Select a type.'
      ),
      MessageDisplay___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_2__MessageDisplay_scss___default.a.buttonContainer },
        MessageDisplay___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { onClick: function onClick() {
              return typeButtonClick('cats');
            } },
          'Cats'
        ),
        MessageDisplay___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { onClick: function onClick() {
              return typeButtonClick('dogs');
            } },
          'Dogs'
        ),
        MessageDisplay___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { onClick: function onClick() {
              return typeButtonClick('pie');
            } },
          'Pie'
        )
      )
    );
  }
  function PlayingScreen() {
    return MessageDisplay___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      MessageDisplay___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h1',
        null,
        'Flip over cards to find a match.'
      ),
      MessageDisplay___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Timer_defaultExport, { secondsElapsed: secondsElapsed }),
      MessageDisplay___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_2__MessageDisplay_scss___default.a.buttonContainer },
        MessageDisplay___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { onClick: resetButtonClick },
          'RESET'
        )
      )
    );
  }
  function EndScreen() {
    return MessageDisplay___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      MessageDisplay___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h1',
        null,
        'You have finished the game. You are awesome.'
      ),
      MessageDisplay___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_2__MessageDisplay_scss___default.a.buttonContainer },
        MessageDisplay___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { onClick: resetButtonClick },
          'RESET'
        )
      )
    );
  }
  if (mode === 'start') {
    display = MessageDisplay___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StartScreen, null);
  } else if (mode === 'playing') {
    display = MessageDisplay___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PlayingScreen, null);
  } else {
    display = MessageDisplay___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EndScreen, null);
  }
  return MessageDisplay___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_2__MessageDisplay_scss___default.a.messageScreen },
    display
  );
};

MessageDisplay_MessageDisplay.propTypes = {
  mode: MessageDisplay___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  secondsElapsed: MessageDisplay___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  resetButtonClick: MessageDisplay___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  typeButtonClick: MessageDisplay___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
/* harmony default export */ var MessageDisplay_defaultExport = (MessageDisplay_MessageDisplay);
// CONCATENATED MODULE: ./src/components/Game/Game.js
/* harmony import */ var Game___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var Game___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Game___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Game___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var Game___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(Game___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Game_scss__ = __webpack_require__("57t0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Game_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Game_scss__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Game_Game = function (_React$Component) {
  _inherits(Game, _React$Component);

  function Game() {
    _classCallCheck(this, Game);

    var _this = _possibleConstructorReturn(this, (Game.__proto__ || Object.getPrototypeOf(Game)).call(this));

    _this.state = { mode: 'start', cards: [], secondsElapsed: 0 };
    _this.typeButtonClick = _this.typeButtonClick.bind(_this);
    _this.resetButtonClick = _this.resetButtonClick.bind(_this);
    _this.handleClick = _this.handleClick.bind(_this);
    _this.numberOfCards = 8;
    _this.activeCards = [];
    _this.numberOfMatches = 0;
    return _this;
  }

  _createClass(Game, [{
    key: 'typeButtonClick',
    value: function typeButtonClick(type) {
      this.getData(type);
    }
  }, {
    key: 'resetButtonClick',
    value: function resetButtonClick() {
      this.setState({ mode: 'start', cards: [], secondsElapsed: 0 });
      this.activeCards = [];
      this.numberOfMatches = 0;
    }
  }, {
    key: 'chooseRandomImages',
    value: function chooseRandomImages(images) {
      // Select 8 random images
      var imageSet = new Set();
      while (imageSet.size < this.numberOfCards) {
        // Select a random image location
        var imageLocation = Math.floor(Math.random() * Math.floor(images.length));
        // Add the image url to the set we will use to generate cards
        imageSet.add(images[imageLocation]);
      }
      // return it as an array so we can grab the index later
      return [].concat(_toConsumableArray(imageSet));
    }

    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'shuffle',
    value: function shuffle(deck) {
      for (var i = deck.length - 1; i > 0; i -= 1) {
        var j = Math.floor(Math.random() * i);
        var temp = deck[i];
        deck[i] = deck[j];
        deck[j] = temp;
      }
      return deck;
    }
  }, {
    key: 'mapDataToCards',
    value: function mapDataToCards(images) {
      var imageArr = this.chooseRandomImages(images);
      // Use the image urls to generate our cards data
      var cardsArr = [];
      imageArr.forEach(function (image, index) {
        cardsArr.push({ img: image, id: 'card' + index, isFlipped: false }, { img: image, id: 'card' + index, isFlipped: false });
      });
      this.setState({ cards: this.shuffle(cardsArr), mode: 'playing' });
    }

    // Pull in the stock photos we will use on the cards

  }, {
    key: 'getData',
    value: function getData(type) {
      var _this2 = this;

      fetch('data/' + type + '.json').then(function (response) {
        return response.json();
      }).then(function (data) {
        // Work with JSON data here
        _this2.mapDataToCards(data.images);
      }).catch(function () {
        console.warn('failed to get data');
      });
    }
  }, {
    key: 'handleClick',
    value: function handleClick(e, id, index) {
      var _this3 = this;

      // return if we already have two cards selected
      if (this.activeCards.length >= 2) {
        return;
      }
      // Flip the card
      this.setState(function (prevState) {
        prevState.cards[index].isFlipped = !prevState.cards[index].isFlipped;
        return prevState;
      });
      // Return if they've just clicked the same card twice
      if (this.activeCards[0] && index === this.activeCards[0].index) {
        return;
      }
      // Otherwise, store the data
      this.activeCards.push({ id: id, index: index });
      // If this is the second card, check for a match
      if (this.activeCards.length === 2) {
        // Increment their score if there's a match
        if (this.activeCards[0].id === this.activeCards[1].id) {
          this.numberOfMatches = this.numberOfMatches + 1;
          this.activeCards = [];
          if (this.numberOfMatches === this.numberOfCards) {
            this.state.mode = 'end';
          }
        } else {
          // Otherwise, flip the cards back
          // Wait a second so we actually see both cards
          setTimeout(function () {
            _this3.setState(function (prevState) {
              prevState.cards[_this3.activeCards[0].index].isFlipped = false;
              prevState.cards[_this3.activeCards[1].index].isFlipped = false;
              _this3.activeCards = [];
              return prevState;
            });
          }, 1000);
        }
      }
    }

    // Logic for the timer

  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      // Set the interval if we don't already have one and we're in playing mode
      if (!this.interval && this.state.mode === 'playing') {
        this.interval = setInterval(this.tick.bind(this), 1000);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.interval);
    }
  }, {
    key: 'tick',
    value: function tick() {
      this.setState({
        secondsElapsed: this.state.secondsElapsed + 1
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _state = this.state,
          cards = _state.cards,
          mode = _state.mode,
          secondsElapsed = _state.secondsElapsed;

      return Game___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_4__Game_scss___default.a.mainContainer },
        Game___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MessageDisplay_defaultExport, {
          mode: mode,
          secondsElapsed: secondsElapsed,
          typeButtonClick: this.typeButtonClick,
          resetButtonClick: this.resetButtonClick
        }),
        Game___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_4__Game_scss___default.a.cardsContainer },
          mode === 'playing' && cards.map(function (card, index) {
            return Game___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Card_defaultExport, {
              img: card.img
              // eslint-disable-next-line react/no-array-index-key
              , key: 'card' + index,
              index: index,
              id: card.id,
              isFlipped: card.isFlipped,
              handleClick: _this4.handleClick
            });
          })
        )
      );
    }
  }]);

  return Game;
}(Game___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Game_Game.PropTypes = {
  mode: Game___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['start', 'playing', 'end']),
  cards: Game___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  secondsElapsed: Game___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};
/* harmony default export */ var Game_defaultExport = (Game_Game);
// CONCATENATED MODULE: ./src/components/App/index.js
/* harmony import */ var App___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var App___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(App___WEBPACK_IMPORTED_MODULE_0_react__);



var App_App = function App() {
  return App___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    App___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Game_defaultExport, null)
  );
};

/* harmony default export */ var App_defaultExport = (App_App);
// CONCATENATED MODULE: ./src/client/index.js
/* harmony import */ var client___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var client___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(client___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__("O27J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);




var root = document.querySelector('#root');
__WEBPACK_IMPORTED_MODULE_1_react_dom__["render"](client___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(App_defaultExport, null), root);

/***/ }),

/***/ "aFXg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"timer":"Timer-timer--_2kNL"};

/***/ })

},["EAxn"]);


// WEBPACK FOOTER //
// main-de1d8e149d46b7459371.js